// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {DisplayTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/DisplayTab';
import {InboxTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InboxTab';
import styles from '@app/features/user/components/modals/tabs/chat_settings_tab/Inline.module.css';
import {InputTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InputTab';
import {InteractionTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InteractionTab';
import {LinksTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/LinksTab';
import {MediaTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/MediaTab';
import {SearchEnginesTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/SearchEnginesTab';
import {SidebarTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/SidebarTab';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const ChatSettingsInlineContent: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<div className={styles.container}>
			<SettingsSection id="display" title={t`Display`}>
				<DisplayTabContent />
			</SettingsSection>
			<SettingsSection id="media" title={t`Media`}>
				<MediaTabContent />
			</SettingsSection>
			<SettingsSection id="input" title={t`Input`}>
				<InputTabContent />
			</SettingsSection>
			<SettingsSection id="interaction" title={t`Interaction`}>
				<InteractionTabContent />
			</SettingsSection>
			<SettingsSection id="links" title={t`External Links`}>
				<LinksTabContent />
			</SettingsSection>
			<SettingsSection id="search_engines" title={t`Search Engines`}>
				<SearchEnginesTabContent />
			</SettingsSection>
			<SettingsSection id="sidebar" title={t`Sidebar`}>
				<SidebarTabContent />
			</SettingsSection>
			<SettingsSection id="inbox" title={t`Inbox`}>
				<InboxTabContent />
			</SettingsSection>
		</div>
	);
});
